var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJira = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.8323 7.60825L8.60375 1.58395L8 1L3.31134 5.53485L1.16763 7.60825C0.944124 7.8247 0.944124 8.1753 1.16763 8.39175L5.45125 12.5349L8 15L12.6886 10.4651L12.7612 10.3949L14.8323 8.39175C15.0559 8.1753 15.0559 7.8247 14.8323 7.60825ZM8 10.0697L5.8601 8L8 5.9303L10.1399 8L8 10.0697Z",
  fill: "#4F4F4F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99995 5.9303C6.59895 4.57504 6.5921 2.37997 7.9847 1.0166L3.30176 5.54405L5.8505 8.0092L7.99995 5.9303Z",
  fill: "#4F4F4F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1456 7.99438L8 10.0696C8.67625 10.7233 9.0562 11.6101 9.0562 12.5347C9.0562 13.4594 8.67625 14.3462 8 14.9999L12.6944 10.4595L10.1456 7.99438Z",
  fill: "#4F4F4F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJira);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jira.0764a189a3a110d95dc85dbd5dfee881.svg";